export const networkStatus = {
  notAsked: 'notAsked',
  pending: 'pending',
  fulfilled: 'fulfilled',
  rejected: 'rejected',
};
